import React, { useState } from "react";
import classes from "./Search.module.css";
import AutoComplete from "../../../Shared/AutosuggestV2/Autosuggestv2";

const CUSTOM_STYLES = {
  placeholder: (base) => ({ ...base, fontSize: "14px" }),
  input: (base) => ({ ...base, fontSize: "14px" }),
  singleValue: (base) => ({ ...base, fontSize: "14px" }),
};

const Search = ({ requestDataForLocation }) => {
  const [inputValue, setInputValue] = useState("");

  const onLocationSelect = (obj) => {
    if (!obj) {
      requestDataForLocation("", "Search");
      return;
    }
    requestDataForLocation(obj.location, "Search");
    setInputValue(obj.location_name || obj.value || "");
  };

  return (
    <div className={classes.container}>
      {/* Section: Search Location */}
      <label>Plant Location/District:</label>
      <AutoComplete
        value={inputValue ? { label: inputValue, value: inputValue } : null}
        placeholder="Search Location"
        onChange={setInputValue}
        onSelect={onLocationSelect}
        className="w-100"
        customStyles={CUSTOM_STYLES}
        isClearable={false}
      />
    </div>
  );
};

export default Search;